import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routerList = [
    {
        path: '/',
        component: () => import( '../../pages/passport.vue'),
        name:'passport',
        meta: {title: '登录'},
    },
	
	{
	    path: '/404',
	    component: () => import( '../../pages/nodata/404.vue'),
	    name:'nodata404',
	    meta: {title: '抱歉您找的页面失踪了'},
	},
	{
	    path: '/Noaccess',
	    component: () => import( '../../pages/nodata/noaccess.vue'),
	    name:'noaccess',
	    meta: {title: '很抱歉您暂时没有权限访问该页面'},
	}
];

const storeRouter = {
	    path: "/layout",
	    component: () => import('../../pages/layout.vue'),
	    meta: {title: '数字库房管理中心'},
	    name: 'layout',
		children:[
			
		]
}

const files = require.context('./routers', false, /\.js$/)

files.keys().forEach(key => {
    let menuLocal = files(key).default;
    for(var  a in menuLocal){
        storeRouter.children.push(menuLocal[a]);
    }
})
routerList.push(storeRouter);


const routerObj = new VueRouter({
    routes:routerList
});

//console.log(routerList);

routerObj.beforeEach((to, from, next) => { 
     if(to.name == null){
        next({
            path:'/404'
        });
     }else{
       document.title =  to.meta.title + ' - 数字库房'
       next();
     }
})

export default routerObj;